import React from 'react';
import InfoModal from '../../../../../components/data-display/InfoModal';
import Paragraph from '../../../../../components/common/Paragraph';

const TaxResidenceModal = () => (
  <InfoModal
    buttonLabel="Sobre Residencia Tributaria"
    title="Residencia Tributaria para efectos del decreto n°418 de abril de 2017"
    width={780}
  >
    <Paragraph align="justify">
      Por este acto el Cliente, personalmente o representando en la forma indicada y encontrándose
      facultado para ello, se obliga a entregar a Vantrust Capital Corredores de Bolsa S.A. la
      siguiente información: (i) aquella que le sea solicitada con el objeto de dar cumplimiento a
      las normas CRS, o a la normativa de cualquier otro país haya implementado para evitar la
      evasión tributaria de sus contribuyentes en el extranjero; y (ii) toda otra información
      solicitada con el objeto de cumplir con el requerimiento de entrega de información efectuado
      por la autoridad tributaria local o extranjera bajo CRS o respecto de cualquier normativa
      extranjera que tenga por objeto evitar la evasión tributaria de sus contribuyentes.
    </Paragraph>
    <Paragraph align="justify">
      El cliente autoriza expresamente a Vantrust Capital Corredores de Bolsa S.A para entregar al
      Servicio de Impuestos Internos de Chile o a las autoridades tributarias extranjeras
      correspondientes, ya sea directa o indirectamente: (i) información personal, incluyendo pero
      no limitada a, su nombre o razón social, nacionalidad, país de constitución, dirección, número
      de identificación tributario, y autoriza además, a que dicha información personal sea
      entregada respecto de sus socios o participantes que sean residentes fiscales de un país
      extranjero; (ii) el número de sus cuentas corrientes bancarias u otras cuentras financieras
      que mantenga en Vantrust Capital Corredores de Bolsa S.A., así como sus respectivos
      movimientos y saldos; y (iii) toda otra información requerida por la autoridad tributaria
      extranjera correspondiente, directamente o a través de las autoridades locales o extranjeras
      que correspondan bajo CRS y respecto de cualquier normativa extranjera que tenga por objeto
      evitar la evasión tributaria de sus contribuyentes en el extranjero ya sean éstas de carácter
      personal, relativa a los activos de su propiedad, a sus operaciones bancarias o financieras o
      de cualquier otra naturaleza, comprendiéndose en dicha información incluso toda aquella
      sometida a secreto o reserva bancaria bajo la legislación chilena.
    </Paragraph>

    <Paragraph align="justify" strong>
      El cliente se obliga a informar a Vantrust Capital Corredores de Bolsa S.A. cualquier cambio
      de estado o circunstancias que tenga lugar en el futuro en virtud de la cual sea necesario
      modificar la información entregada por medio de esta declaración dentro del plazo máximo de 30
      días corridos contados desde la fecha en que tenga lugar el referido cambio.
    </Paragraph>

    <Paragraph align="justify">
      En virtud del presente instrumento el Cliente declara: a) Haber sido informado respecto de las
      normas CRS o Common Reporting Standard, cuyo objeto es combatir la evasión fiscal
      internacional, a través de la cooperación entre las administraciones tributarias de los
      distintos Estados participantes de la misma. b) Estar en conocimiento que Vantrust Capital de
      Corredores de Bolsa S.A. se encuentra obligada a (i) identificar aquellos clientes que sean
      residentes fiscales de un país extranjero; (ii) proporcionar a la autoridad tributaria,
      directamente o a través de otras autoridades chilenas o extranjeras, información de
      identificación personal sobre los contribuyentes que mantengan residencia fiscal en cualquier
      país extranjero, así como sobre las cuentas corrientes bancarias y demás cuentas financieras,
      u otros activos de que éstos sean titulares, o de las operaciones financieras que ejecuten. c)
      Que, a su entender, toda la información y datos proporcionados en la presente declaración son
      precisos, correctos y completos.
    </Paragraph>
  </InfoModal>
);

export default TaxResidenceModal;
